var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSuccessfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3586 25.4389C48.1734 25.2522 47.953 25.104 47.7102 25.0028C47.4675 24.9017 47.2071 24.8496 46.944 24.8496C46.681 24.8496 46.4206 24.9017 46.1778 25.0028C45.9351 25.104 45.7147 25.2522 45.5295 25.4389L30.6866 40.3018L24.4506 34.0458C24.2583 33.8601 24.0313 33.714 23.7825 33.616C23.5338 33.5179 23.2681 33.4699 23.0008 33.4745C22.7335 33.4791 22.4697 33.5364 22.2244 33.6429C21.9792 33.7495 21.7574 33.9033 21.5716 34.0956C21.3859 34.2879 21.2398 34.515 21.1418 34.7637C21.0438 35.0125 20.9957 35.2781 21.0003 35.5454C21.0049 35.8128 21.0622 36.0766 21.1687 36.3218C21.2753 36.567 21.4292 36.7888 21.6215 36.9746L29.272 44.6251C29.4572 44.8119 29.6776 44.9601 29.9204 45.0612C30.1632 45.1624 30.4236 45.2145 30.6866 45.2145C30.9496 45.2145 31.21 45.1624 31.4528 45.0612C31.6956 44.9601 31.9159 44.8119 32.1011 44.6251L48.3586 28.3677C48.5608 28.1811 48.7222 27.9547 48.8326 27.7026C48.943 27.4506 49 27.1785 49 26.9033C49 26.6282 48.943 26.356 48.8326 26.104C48.7222 25.8519 48.5608 25.6255 48.3586 25.4389V25.4389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccessfull);
export default __webpack_public_path__ + "static/media/ic-successfull.d49caaa2cc19f58625b41ac2f89c962c.svg";
export { ForwardRef as ReactComponent };